import styled, { css, CSSProperties } from "styled-components";

interface IStyleProps {
  selected?: boolean;
  absolute?: boolean;
  borderColorValue?: string;
  backgroundColorValue?: string;
}

export const comboboxTitleStyle: CSSProperties = {
  fontFamily: "Lato",
  fontSize: "18px",
  height: 'auto',
  padding: "18px 0px 8px 0px",
  color: "black",
}

export const comboboxInputStyle: CSSProperties = {
  height: "31px",
  width: "184px",
}

export const optionContainerStyle: CSSProperties = {
  top: "100px",
}

export const Root = styled.div`
  position: absolute;
  min-width: 353px;
  border-radius: 5px;
  box-shadow: 0 4px 5px 2px rgba(0, 0, 0, 0.05);
  border: solid 1px rgba(18, 36, 66, 0.1);
  background-color: #fff;
  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const Top = styled.div`
  font-weight: bold;
  padding: 20px 28px;
`;

export const Bottom = styled.div`
  display: flex;
  border-top: solid 1px rgba(43, 58, 102, 0.2);
`;

export const VerticalOptions = styled.div`
  width: 69px;
  background-color: rgba(43, 58, 102, 0.1);
`;

export const Option = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 11px 0px;
  background-color: ${(props: IStyleProps) => (props.selected ? "#FFFFFF" : "#FFFFFF00")};
  &:hover {
    background-color: ${(props: IStyleProps) => (props.selected ? "#FFFFFF" : "rgba(43, 58, 102, 0.1)")};
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 20px 24px;
`;

export const Title = styled.div`
`

export const Controls = styled.div`
  margin-top: 20px;
`

/*
  Color styled components
*/

export const ColorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const ColorTextSliderContainer = styled.div`
  flex: 1;
`;

export const ColorSliderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ColorAuxText = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

export const Color = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 5px;
  margin-right: 15px;
  border: solid 2px ${(props: IStyleProps) => (props.borderColorValue ?? "#a5a5a5")};
  background-color: ${(props: IStyleProps) => (props.backgroundColorValue ?? "#FFFFFF")};
`;

export const ColorPicker = styled.div`
  ${(props: IStyleProps) => (props.absolute && css`
    top: 71px;
    right: 21px;
    position: absolute;
    width: 295px;
    height: 293px;
    border-radius: 5px;
    box-shadow: 0 4px 5px 2px rgba(0, 0, 0, 0.05);
    border: solid 1px rgba(18, 36, 66, 0.1);
    background-color: #fff;
    z-index: 100;
  `)};
`;

export const ColorPickerTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  padding: 20px 31px;
  margin-top: 7px;
  border-bottom: solid 1px rgba(43, 58, 102, 0.2);
`;

export const ColorGeneratorContainer = styled.div`
  ${(props: IStyleProps) => (props.absolute && css`
    margin-top: 27px;
    padding: 0px 31px;
  `)};
`;

export const OpacityPercentage = styled.div`
  font-weight: bold;
`;

export const ColorActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  ${(props: IStyleProps) => (props.absolute && css`
    margin-top: 20px;
    padding: 0px 31px;
  `)};
`;

export const ColorActions = styled.div`
  display: flex;
  height: 25px;
  width: 100px;
`;

/*
  Text styled components
*/

export const TextPicker = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
`;

export const TextColor = styled.div`
  min-width: 38px;
  height: 38px;
  border-radius: 5px;
  margin-left: 10px;
  border: solid 2px ${(props: IStyleProps) => (props.borderColorValue ?? "#a5a5a5")};
  background-color: ${(props: IStyleProps) => (props.backgroundColorValue ?? "#FFFFFF")};
  cursor: pointer;
`;

export const TextLabel = styled.div`
  font-size: 18px;
  padding: 50px 0px 8px 0px;
`;